import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faWallet } from '@fortawesome/free-solid-svg-icons'
import BaseModal from './BaseModal'
import depositImg from '../../assets/images/deposit.png'
const DepositToWallets = () => {
    return (
        <BaseModal modalId="modalDepositToWallets" modalTitle="Deposit" modalTitleIcon={faWallet}>
            <form action="#" method="post" className="text-dark text-center">
                <img src={depositImg} alt="" className="rounded-circle w-50" />
                    <div className="row text-left">
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <label className="small">From my:</label>
                            <select className="form-control">
                                <option>Gt Bank</option>
                                <option>Firstbank Master Card</option>
                            </select>
                        </div>
                        <div className="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                            <label className="small">To my: </label>
                            <select className="form-control">
                                <option>Pouch</option>
                                <option>Binance</option>
                                <option>Coinbase</option>
                            </select>
                        </div>
                    </div>
                    <div className="row text-left">
                        <div className="col form-group">
                            <input type="text" className="form-control" placeholder="0.00" />
                        </div>
                    </div>
                <button type="submit" className="btn btn-purple shadow-sm w-100 mt-4">Complete <FontAwesomeIcon icon={faCheckCircle} /></button>
            </form>
        </BaseModal>
    )
}

export default DepositToWallets